import React, { Component } from 'react'
import { connect } from 'react-redux'

class AboutMCP extends Component {
    renderIntegrationTool() {
        return null
    }

    renderDocument() {
        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>About Multi-Currency Pricing (MCP)</b></span>
                <p style={{marginTop: '3vh'}}>Multi-currency pricing (MCP) is a financial service which allows businesses to price goods and services in a variety of foreign currencies, while continuing to receive settlement and reporting in Canadian dollars. MCP allows cardholders to shop, view prices and pay in the currency of their choice.</p>
                <p>MCP is only available when processing Visa and Mastercard transactions.</p>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode };
}

export default connect(mapStateToProps, {})(AboutMCP)
